import React from "react";
import { Link } from "react-router-dom";

import EventNavigation from "../EventsPage/EventNavigation/EventNavigation";
import Footer from "../EventsPage/Footer/Footer";
import "./privacy_policy.css";

const PrivacyPolicyPage = () => {
  return (
    <>
      <EventNavigation />

      <main id="privacy_policy_page">
        <section id="privacy_policy_hero">
          <p id="privacy_policy_eyebrow">Legal</p>
          <h1 id="privacy_policy_title">Privacy Policy</h1>
          <p id="privacy_policy_intro">
            <strong>PRIVACY POLICY - PROPTECH CLUB</strong>
            <br />
            Last updated: April 2026
          </p>
          <p id="privacy_policy_summary">
            PropTech Club ("we", "our", or "us") is operated by Landtrack.pk.
            This Privacy Policy explains how we collect, use, and protect your
            information when you use the PropTech Club mobile application.
          </p>
        </section>

        <section id="privacy_policy_content">
          <article className="privacy_policy_card">
            <h2>1. Information We Collect</h2>

            <h3>Account Information</h3>
            <p>
              When you create an account, we collect your full name, email
              address, WhatsApp number, company name, professional role, and
              location.
            </p>

            <h3>Profile Information</h3>
            <p>
              You may optionally provide a profile picture, biography, current
              focus, and details about what you are looking for professionally.
            </p>

            <h3>Usage Information</h3>
            <p>
              We collect information about how you use the app, including
              connections made, events attended, messages sent, and articles
              read.
            </p>
          </article>

          <article className="privacy_policy_card">
            <h2>2. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>Provide and operate the PropTech Club platform</li>
              <li>Display your profile to other members of the network</li>
              <li>Send connection requests and messages between members</li>
              <li>Notify you about events, updates and platform activity</li>
              <li>Improve the app and develop new features</li>
            </ul>
          </article>

          <article className="privacy_policy_card">
            <h2>3. Information Sharing</h2>
            <p>
              Your profile information - including your name, role, company,
              location and profile picture - is visible to other registered
              members of PropTech Club.
            </p>
            <p>
              Your WhatsApp number is only shared with members you are
              connected with.
            </p>
            <p>We do not sell your personal information to third parties.</p>
            <p>
              We use Supabase (
              <a
                href="https://supabase.com"
                target="_blank"
                rel="noreferrer noopener"
              >
                supabase.com
              </a>
              ) as our database and storage provider. Your data is stored
              securely on Supabase infrastructure.
            </p>
          </article>

          <article className="privacy_policy_card">
            <h2>4. Data Storage and Security</h2>
            <p>
              Your data is stored on secure cloud servers. We implement
              industry-standard security measures to protect your information.
              However, no method of transmission over the internet is 100%
              secure.
            </p>
          </article>

          <article className="privacy_policy_card">
            <h2>5. Your Rights</h2>
            <p>
              You may update or delete your profile information at any time
              through the app. To request complete account deletion, contact us
              at the email address below.
            </p>
          </article>

          <article className="privacy_policy_card">
            <h2>6. Children's Privacy</h2>
            <p>
              PropTech Club is intended for professional use by adults aged 18
              and above. We do not knowingly collect information from children
              under 18.
            </p>
          </article>

          <article className="privacy_policy_card">
            <h2>7. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will
              notify you of significant changes through the app or by email.
            </p>
          </article>

          <article className="privacy_policy_card privacy_policy_contact">
            <h2>8. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy, please
              contact us at:
            </p>
            <p>
              Email: <a href="mailto:info@proptechclub.org">info@proptechclub.org</a>
            </p>
            <p>
              Website:{" "}
              <a
                href="https://proptechclub.org"
                target="_blank"
                rel="noreferrer noopener"
              >
                proptechclub.org
              </a>
            </p>
            <Link id="privacy_policy_back_link" to="/">
              Back to PropTech Club
            </Link>
          </article>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default PrivacyPolicyPage;
